module.exports = __webpack_public_path__ + "static/media/orders.4cff37ce.svg";